import { A11yModule } from '@angular/cdk/a11y';
import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDialogModule, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslocoModule } from '@jsverse/transloco';

import { PrismButtonComponent, PrismCheckboxComponent, PrismIconComponent } from '@shure/prism-angular-components';
import { provideInlineScope } from '@shure/shared/angular/utils/i18n';

import { ConfirmDialogData, DialogBody, ShowIcon } from './confirm-dialog.component.models';

@Component({
	selector: 'sh-confirm-dialog',
	templateUrl: './confirm-dialog.component.html',
	styleUrls: ['./confirm-dialog.component.scss'],
	imports: [
		CommonModule,
		FlexLayoutModule,
		MatDialogModule,
		MatCardModule,
		TranslocoModule,
		PrismButtonComponent,
		MatButtonModule,
		PrismCheckboxComponent,
		PrismIconComponent,
		A11yModule
	],
	providers: [provideInlineScope('scConfirmDialog', (lang) => import(`../i18n/${lang}`))]
})
export class ConfirmDialogComponent {
	public doNotShowDialog = false;
	public readonly showIcon = ShowIcon;
	constructor(
		@Inject(MAT_DIALOG_DATA) public readonly data: ConfirmDialogData,
		private readonly dialogRef: MatDialogRef<ConfirmDialogComponent>
	) {}

	public toggleDoNotShowDialog(doNotShowDialog: boolean): void {
		this.doNotShowDialog = doNotShowDialog;
	}

	public isTextObject(line: string | DialogBody): line is DialogBody {
		return typeof line !== 'string';
	}

	public closeDialog(result: { confirmed: boolean; doNotShowDialog: boolean }): void {
		this.dialogRef.close(result);
	}
}
